import {SIGNAL_R_CONSTANTS} from '../constants/constants';

export const isConnected = connection => connection.state === SIGNAL_R_CONSTANTS.CONNECTED;
